function fn_comp_offers() {
    var $fn = $(".comp_offers");

    if ($fn.length) {
        var $slider = $fn.find(".offers_slider");

        $slider.slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            autoplay: true,
            autoplaySpeed: 5000,
            nextArrow: "<span class=\"slick-arrow slick-next icon--chevron-right\"></span>",
            prevArrow: "<span class=\"slick-arrow slick-prev icon--chevron-left\"></span>",
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        })
    }
}